// Base de commentaires à la 2ème personne, piochés au hasard selon la situation, par langue.
// Convention : chaque phrase est encadrée par le même picto au début et à la fin.
export const commentsBank = Object.freeze({
  fr: {
    start: [
      '🧀 Prêt à courir après ton repas ? 🧀', '🐾 Fais chauffer tes petites pattes ! 🐾', '⏱️ Le chrono tourne, fonce ! ⏱️',
      "🐀 Ne laisse pas le rat te voler ton fromage ! 🐀", "🐭 C'est parti pour le labyrinthe de la faim ! 🐭", '⚡ Prouve que tu es la souris la plus rapide ! ⚡',
      '🏁 Attention au départ, cours ! 🏁', "🤤 Le fromage t'attend, ne traîne pas ! 🤤", '🦾 Montre-moi ce dont tu es capable ! 🦾',
      '🗺️ Trouve ton chemin, petite souris ! 🗺️', '🧩 Un nouveau dédale pour te mettre au défi ! 🧩', '🚀 Go ! Go ! Go ! 🚀',
      '🧀 Que la course au fromage commence ! 🧀',
    ],
    win: [
      "🧀 Un festin royal t'attend, champion ! 🧀", '⚡ Quelle vitesse fulgurante, bravo ! ⚡', '🦅 Tu as littéralement survolé ce labyrinthe ! 🦅',
      '🧀 Impressionnant, le fromage est tout à toi ! 🧀', '🥇 Tu es le maître incontesté du dédale ! 🥇', '✨ Score parfait pour une souris parfaite ! ✨',
      "🏎️ Rien ne peut t'arrêter ! 🏎️", "💥 C'est ce qu'on appelle une victoire écrasante ! 💥", '🍽️ Tu as dévoré ce niveau ! 🍽️',
      '🏆 Un véritable exploit rongeur ! 🏆', '🎯 Magnifique trajectoire, très pro ! 🎯', "🐀 Le rat n'a même pas eu le temps d'y goûter ! 🐀",
    ],
    survive: [
      "😅 Ouf, c'était moins une pour ton repas ! 😅", '🐢 Pas très rapide, mais tu as ton fromage ! 🐢', '🧱 Tu as pris ton temps pour admirer les murs ? 🧱',
      "🪙 Le principal c'est d'arriver en vie, non ? 🪙", '⏱️ Un peu lent, mais ça passe pour cette fois ! ⏱️', '🐌 Tu aurais pu courir un tout petit peu plus vite... 🐌',
      '🪒 Victoire sur le fil du rasoir ! 🪒', "🐀 Le rat a déjà croqué dans ton fromage ! 🐀", "🤷 Bon, tu l'as eu, c'est l'essentiel. 🤷",
      '🏅 Encore un effort et tu seras un champion. 🏅', "🧭 Tu t'es perdu en route ? L'essentiel est là ! 🧭", "🥉 Ce n'est pas ton meilleur temps, mais bravo ! 🥉",
      '🏃 Sauvé de justesse, la prochaine fois fonce ! 🏃',
    ],
    lose: [
      "🐀 Trop lent, le rat a tout dévoré ! 🐀", '🤦 Tu as complètement raté ton coup ! 🤦', '🐢 Même une tortue aurait fait mieux... 🐢',
      "😭 Adieu joli petit bout d'emmental ! 😭", "🍽️ Le rat s'est régalé à ta place ! 🍽️", '💨 Il va falloir courir bien plus vite que ça ! 💨',
      "😴 Tu t'es endormi dans un cul-de-sac ? 😴", "🪤 Le piège s'est refermé, dommage ! 🪤", "🔥 C'est un échec cuisant, petite souris ! 🔥",
      "🧀 Il ne reste même plus une miette... 🧀", '☠️ Game Over pour ton estomac ! ☠️', '🧠 Raté ! Essaie encore de te concentrer ! 🧠',
    ],
  },
  en: {
    start: [
      '🧀 Ready to chase down your dinner? 🧀', '🐾 Warm up those little paws! 🐾', '⏱️ The clock is ticking, move it! ⏱️',
      "🐀 Don't let the rat steal your cheese! 🐀", '🐭 Welcome to the hungry maze! 🐭', "⚡ Prove you're the fastest mouse around! ⚡",
      '🏁 Ready, set, run! 🏁', "🤤 The cheese is waiting, don't dawdle! 🤤", "🦾 Show me what you've got! 🦾",
      '🗺️ Find your way, little mouse! 🗺️', '🧩 A brand new maze to test you! 🧩', '🚀 Go, go, go! 🚀',
      '🧀 Let the cheese race begin! 🧀',
    ],
    win: [
      '🧀 A royal feast awaits you, champ! 🧀', '⚡ Lightning speed, well done! ⚡', '🦅 You practically flew through that maze! 🦅',
      '🧀 Impressive, the cheese is all yours! 🧀', "🥇 You're the undisputed master of the maze! 🥇", '✨ A perfect score for a perfect mouse! ✨',
      '🏎️ Nothing can stop you! 🏎️', "💥 Now that's what you call a landslide win! 💥", '🍽️ You devoured that level! 🍽️',
      '🏆 A truly rodent-sized achievement! 🏆', '🎯 Beautiful run, very pro! 🎯', "🐀 The rat didn't even get a taste! 🐀",
    ],
    survive: [
      '😅 Phew, that was close for your dinner! 😅', '🐢 Not exactly fast, but you got your cheese! 🐢', '🧱 Were you busy admiring the walls? 🧱',
      "🪙 The main thing is you made it out alive, right? 🪙", "⏱️ A bit slow, but it'll do this time! ⏱️", '🐌 You could have run just a tiny bit faster... 🐌',
      '🪒 A razor-thin victory! 🪒', '🐀 The rat already took a bite of your cheese! 🐀', "🤷 Well, you got it, that's what matters. 🤷",
      "🏅 One more push and you'll be a champion. 🏅", '🧭 Got lost along the way? At least you made it! 🧭', '🥉 Not your best time, but well done! 🥉',
      '🏃 Saved by the bell, run faster next time! 🏃',
    ],
    lose: [
      '🐀 Too slow, the rat gobbled it all! 🐀', '🤦 You totally blew it! 🤦', '🐢 Even a turtle would have done better... 🐢',
      '😭 Farewell, tasty little piece of cheese! 😭', '🍽️ The rat enjoyed your dinner for you! 🍽️', "💨 You're going to need to run much faster than that! 💨",
      '😴 Did you fall asleep in a dead end? 😴', '🪤 The trap snapped shut, too bad! 🪤', '🔥 That\'s a crushing defeat, little mouse! 🔥',
      "🧀 Not a single crumb left... 🧀", '☠️ Game over for your stomach! ☠️', '🧠 Missed it! Try to focus harder next time! 🧠',
    ],
  },
});

export function pickComment(lang, situation, random = Math.random) {
  const phrases = commentsBank[lang]?.[situation] ?? commentsBank.en[situation] ?? [];
  return phrases[Math.floor(random() * phrases.length)] ?? '';
}
